import { SchoolsDocument, useSchoolsQuery } from 'api/generated';
import { bytes2Mebibytes } from 'utils/math';
export const useSchoolsQueryApi = () => {
    const { data, ...rest } = useSchoolsQuery();
    const schools = (data?.schools ?? [])
        .map((school) => ({
        ...school,
        schoolIdentifier: school.schoolIdentifier ?? '',
        storageSizeBytes: bytes2Mebibytes(school.storageSizeBytes),
    }))
        .sort((a, b) => a.name.localeCompare(b.name));
    return { data: { __typename: 'Query', schools }, ...rest };
};
export const getCreateSchoolMutationOptions = (school) => ({
    refetchQueries: [SchoolsDocument],
    variables: {
        input: school,
    },
});
export const getUpdateSchoolMutationOptions = (school) => ({
    variables: {
        input: school,
    },
});
export const getDeleteSchoolMutationOptions = (id) => ({
    refetchQueries: [SchoolsDocument],
    variables: {
        id,
    },
});
